import React, { useMemo, useState } from "react";
import { connect } from "react-redux";

import { EMPTY_STRING, eventBookingConstants } from "../../../../constants";
import {
  formatCustomDate,
  convertEpochToTimezoneMillis,
} from "../../../../shared";
import ShutterBSelectionCard from "../../../../shared/components/Cards/ShutterBSelectionCard";
import {
  eventBookingActions,
  shutterbProfileActions,
} from "../../../../redux/actions";
import ShutterBProfileView from "../../ShutterBProfile/ShutterBProfileView";

const ShutterBSelectionPage = (props) => {
  const [isProfileViewShutterBSelected, setIsProfileViewShutterBSelected] =
    useState(false);

  // Spinner
  const spinner = useMemo(
    () =>
      props.spinnerActions.findIndex(
        (f) => f === eventBookingConstants.GET_AVAILABLE_SHUTTERB
      ),
    [props.spinnerActions]
  );

  const selectedFormEvent = Array.isArray(props.availableShutterBs)
    ? props.availableShutterBs[0]
    : null;

  // Available shutterbs
  const shutterbList = useMemo(() => {
    return props.availableShutterBs[0]?.items || [];
  }, [props.availableShutterBs]);

  // Toggle selection of a shutterB
  const toggleSelectShutterB = (eventId, shutterB) => {
    const updatedList = props.availableShutterBs.map((eventItem) => {
      return {
        ...eventItem,
        items: eventItem.items.map((sb) => {
          if (sb.sbUserId === shutterB.sbUserId) {
            // Toggle if already selected, otherwise add as true
            return { ...sb, isSelected: !sb.isSelected };
          }
          // Ensure all others are explicitly false
          return { ...sb, isSelected: false };
        }),
      };
    });

    props.setAvaliableShutterB(updatedList);
  };

  const handleViewProfileClick = (shutterbId, isSelected) => {
    setIsProfileViewShutterBSelected(isSelected);
    props.setIsProfileViewShow(true);
    props.getShutterBProfile(shutterbId);
  };

  return (
    <div>
      {props.isProfileViewShow ? (
        <ShutterBProfileView
          handleShutterBClick={toggleSelectShutterB}
          isSelected={isProfileViewShutterBSelected}
          setIsProfileViewShutterBSelected={setIsProfileViewShutterBSelected}
          isFromShutterbSelectionPage={true}
        />
      ) : (
        <>
          <div>
            <div className="shutterb-address text-center mt-3">
              {shutterbList.length > 0 && (
                <p className="font-weight-bold mb-1">
                  select one or more shutterbz to capture this event
                </p>
              )}
              <p className="address-text">
                {selectedFormEvent?.currentLocation || EMPTY_STRING}
              </p>
              <p className="address-text">
                {selectedFormEvent?.duration
                  ? `${selectedFormEvent?.duration} Hour Reservation`
                  : EMPTY_STRING}
              </p>
              <p className="address-text">
                {selectedFormEvent?.sbStartTime
                  ? formatCustomDate(
                      convertEpochToTimezoneMillis(
                        selectedFormEvent.sbStartTime,
                        selectedFormEvent.sourceTimeZone
                      )
                    )
                  : EMPTY_STRING}
              </p>
            </div>

            {spinner === -1 && (
              <div className="row">
                {props.availableShutterBs?.length &&
                shutterbList.length === 0 ? (
                  <div className="col-12 mt-4">
                    <div className="draft-event-shutterB text-center py-5 px-3">
                      <p className="label-content clr-black">
                        Unfortunately, there is no shutterb available for this
                        event.
                      </p>

                      <p className="text-content mt-1">
                        Click to submit your details to one of our hive leads
                        that will work to help secure a shutterb for your event.
                      </p>

                      <div className="d-flex justify-content-center g-3">
                        <button
                          className="button-common button-fill"
                          onClick={() => props.handleNotifyAdmin()}
                        >
                          submit
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  shutterbList.map((shutterB) => (
                    <div
                      key={shutterB.sbUserId}
                      className="col-12 col-md-6 col-custom-6 mt-2 mb-3"
                    >
                      <ShutterBSelectionCard
                        shutterB={shutterB}
                        isSelected={shutterB?.isSelected}
                        onViewProfileClick={handleViewProfileClick}
                        onSelect={() => toggleSelectShutterB(null, shutterB)}
                      />
                    </div>
                  ))
                )}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  spinnerActions: state.system.spinnerActions,
  isProfileViewShow: state.eventBooking.isProfileViewShow,
  availableShutterBs: state.eventBooking.availableShutterBs,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  setIsProfileViewShow: (data) =>
    dispatch(eventBookingActions.setIsProfileViewShow(data)),
  getShutterBProfile: (id) =>
    dispatch(shutterbProfileActions.getShutterBProfile(id)),
  setAvaliableShutterB: (data) =>
    dispatch(eventBookingActions.setAvaliableShutterB(data)),
});

// mapping action and store the function via props
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShutterBSelectionPage);
